import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ResetDetails: {},
  isLoading: false,
  error: {},
  hasData: false,
  ResetSubmitDetails: {},
  submitIsLoading: false,
  submitError: {},
  submitResetEmailVerificationPasswordHasData: false,
  submitResetEmailVerificationPasswordIsLoading: false,
  submitResetEmailVerificationPasswordError: {}
};
const resetSlice = createSlice({
  name: "reset",
  initialState,
  reducers: {
    resetDataRequest: (state, action) => {
      state.isLoading = true;
      state.error = "";
      state.hasData = false;
      state.ResetDetails = {};
    },
    resetDataSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.ResetDetails = action.payload;
    },
    resetDataFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = false;
      state.ResetDetails = {};
    },
    resetDataSubmitFailure: (state, action) => {
      state.submitError = action.payload;
      state.submitIsLoading = false;
      state.submitHasData = false;
      state.ResetSubmitDetails = {};
    },
    resetDataSubmitRequest: (state, action) => {
      state.submitIsLoading = true;
      state.submitError = "";
      state.submitHasData = false;
      state.ResetSubmitDetails = {};
    },
    resetDataSubmitSuccess: (state, action) => {
      state.submitIsLoading = false;
      state.submitError = "";
      state.submitHasData = true;
      state.ResetSubmitDetails = action.payload;
    },
    // ROP reset password for email verfication

    resetPasswordVerficationSubmitFailure: (state, action) => {
      state.submitResetEmailVerificationPasswordError = action.payload;
      state.submitResetEmailVerificationPasswordIsLoading = false;
      state.submitResetEmailVerificationPasswordHasData = false;
      state.ResetSubmitDetails = {};
    },
    resetPasswordVerficationSubmitRequest: (state, action) => {
      state.submitResetEmailVerificationPasswordIsLoading = true;
      state.submitResetEmailVerificationPasswordError = "";
      state.submitResetEmailVerificationPasswordHasData = false;
      state.ResetSubmitDetails = {};
    },
    resetPasswordVerficationSubmitSuccess: (state, action) => {
      state.submitResetEmailVerificationPasswordIsLoading = false;
      state.submitResetEmailVerificationPasswordError = "";
      state.submitResetEmailVerificationPasswordHasData = true;
      state.ResetSubmitDetails = action.payload;
    }
  }
});
export const {
  resetDataRequest,
  resetDataSuccess,
  resetDataFailure,
  resetDataSubmitFailure,
  resetDataSubmitRequest,
  resetDataSubmitSuccess,
  resetPasswordVerficationSubmitRequest,
  resetPasswordVerficationSubmitFailure,
  resetPasswordVerficationSubmitSuccess
} = resetSlice.actions;
export default resetSlice.reducer;